import { useQuery } from 'react-apollo';
import { queries } from '@kiper/account-graphql/invite';

const useFetchGuestFacePhoto = ({ guestHash, skip = false }) => {
  const { data, loading, error } = useQuery(queries.getGuestFacePhoto, {
    variables: { guestHash },
    skip: !guestHash || skip,
    fetchPolicy: 'network-only',
  });

  const photoData = data?.getGuestFacePhoto;
  const facePhotoUrl = photoData?.base64Photo
    ? `data:${photoData.contentType || 'image/jpeg'};base64,${
        photoData.base64Photo
      }`
    : null;

  return {
    facePhotoUrl,
    loading,
    error,
  };
};

export default useFetchGuestFacePhoto;
